import { alpha } from "@mui/material";

const useStyles = (theme, { layoutDir } = {}) => ({
  paper: {
    position: "fixed",
    zIndex: 1501,
    minWidth: 250,
    borderRadius: 2,
    border: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
    userSelect: "none",
  },

  dragHandle: {
    px: 1.5,
    pt: 1.25,
    pb: 1,
    cursor: "grab",
    "&:active": { cursor: "grabbing" },
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },

  dragIcon: {
    color: theme.palette.text.disabled,
    flexShrink: 0,
  },

  title: {
    color: theme.palette.text.primary,
    fontSize: "0.875rem",
    textShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.08)}`,
    flexGrow: 1,
  },

  sectionLabel: {
    fontSize: "0.72rem",
    color: theme.palette.text.secondary,
  },

  algoSelect: {
    fontSize: "0.82rem",
  },

  algoMenuItem: {
    fontSize: "0.82rem",
  },

  directionGroup: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 0.75,
    mb: 1.5,
  },

  directionBtn: (dir) => {
    const selected = layoutDir === dir;
    return {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 0.5,
      py: 1,
      px: 0.5,
      borderRadius: 1.5,
      border: `1px solid ${
        selected ? theme.palette.primary.main : theme.palette.divider
      }`,
      backgroundColor: selected
        ? alpha(theme.palette.primary.main, 0.08)
        : "transparent",
      transition: theme.transitions.create(
        ["border-color", "background-color", "color", "box-shadow"],
        { duration: 150 },
      ),
      "&:hover": {
        borderColor: selected
          ? theme.palette.primary.main
          : alpha(theme.palette.primary.main, 0.4),
        backgroundColor: selected
          ? alpha(theme.palette.primary.main, 0.12)
          : theme.palette.background.hover,
      },
      "&.Mui-focusVisible": {
        boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.35)}`,
      },
    };
  },

  directionIcon: (dir) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color:
      layoutDir === dir
        ? theme.palette.primary.main
        : theme.palette.text.secondary,
  }),

  directionLabel: (dir) => ({
    fontSize: "0.72rem",
    lineHeight: 1.2,
    fontWeight: layoutDir === dir ? 600 : 500,
    color:
      layoutDir === dir
        ? theme.palette.primary.main
        : theme.palette.text.primary,
  }),

  fdBtn: {
    textTransform: "none",
    fontSize: "0.8rem",
    mb: 1.5,
    color:
      layoutDir === "FD"
        ? theme.palette.primary.main
        : theme.palette.text.primary,
    borderColor:
      layoutDir === "FD" ? theme.palette.primary.main : theme.palette.divider,
    fontWeight: layoutDir === "FD" ? 600 : 400,
  },

  spacingValue: {
    fontSize: "0.72rem",
    color: theme.palette.primary.main,
    fontWeight: 600,
  },

  slider: {
    color: theme.palette.primary.main,
  },

  discardBtn: {
    textTransform: "none",
    fontSize: "0.8rem",
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    "&:hover": {
      borderColor: theme.palette.error.dark,
      backgroundColor: alpha(theme.palette.error.main, 0.06),
    },
  },

  saveBtn: {
    boxShadow: "none",
    color: theme.palette.success.main,
    backgroundColor: alpha(theme.palette.success.main, 0.2),
    "&:hover": { backgroundColor: alpha(theme.palette.success.main, 0.1) },
    textTransform: "none",
    fontSize: "0.8rem",
    fontWeight: 600,
  },
});

export default useStyles;
